export default __webpack_public_path__ + "static/media/html.85ef49c3.svg";